var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { JSException } from '../messages';
import { subscribe, unsubscribe } from '../vendor/tracekit';
export default function (app, opts) {
    const options = Object.assign({
        captureExceptions: true,
    }, opts);
    if (options.captureExceptions) {
        const handler = (stackTrace) => {
            const { name, message } = stackTrace, payload = __rest(stackTrace, ["name", "message"]);
            if (name && message) {
                if (Array.isArray(payload.stack)) {
                    payload.stack.forEach((stackFrame) => {
                        if (stackFrame.context && stackFrame.context.length > 200) {
                            stackFrame.offset = stackFrame.column - 100;
                            if (stackFrame.offset < 0) {
                                stackFrame.offset = 0;
                            }
                            stackFrame.context = stackFrame.context.substr(stackFrame.offset, 200);
                        }
                    });
                }
                app.send(JSException(name, message, JSON.stringify(payload)));
            }
        };
        app.attachStartCallback(() => subscribe(handler));
        app.attachStopCallback(() => unsubscribe());
    }
}
